import script from "./ExpandedEvent.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpandedEvent.vue?vue&type=script&setup=true&lang=js"

import "./ExpandedEvent.vue?vue&type=style&index=0&id=129a4fbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-129a4fbc"]])

export default __exports__